export const useScrollToItem = () => {
  /**
   * It scrolls to the element that is passed in as a ref
   * @param {any} ref - any: This is the ref of the element you want to scroll to.
   */
  const scrollToItem = (ref: any): void => {
    setTimeout(
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      }),
      1000
    );
  };

  return {
    scrollToItem,
  };
};
